import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const postPrivacyRequest = (params) => {
    const { pathsContext, ...rest } = params;
    return VerbFetch(`${pathsContext.serverUrl}/privacyrequests`, { method: 'POST', body: rest })
        .then((response) => response)
        .catch((err) => {
            console.error(err);
        });
};

export const putPrivacyRequest = (params) => {
    const { privacyRequestId, body, pathsContext } = params;
    return VerbFetch(`${pathsContext.serverUrl}/privacyrequests/${privacyRequestId}`, {
        method: 'PUT',
        body
    })
        .then((response) => response)
        .catch((err) => {
            console.error(err);
        });
};

export const getPrivacyRequestStatus = (params = {}) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/privacyrequests/status`;
    const url = buildQueryString(rest, baseUrl);
    return VerbFetch(url)
        .then((response) => response)
        .catch((err) => {
            console.error(err);
        });
};
